"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @deprecated use Globe from foundation/Globe
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const WorldGlobe = createSVGIcon(
  <path
    d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m5.544 4.8h-1.876a10.5 10.5 0 0 0-.898-2.572A6.43 6.43 0 0 1 13.544 4.8M6.6 3.058C7.102 2.058 7.64 1.6 8 1.6s.896.454 1.4 1.458q.406.837.624 1.742H5.976A8.6 8.6 0 0 1 6.6 3.058M1.8 9.6a6.44 6.44 0 0 1 0-3.2h2.28a16 16 0 0 0 0 3.2zm.654 1.6H4.33c.186.893.488 1.757.898 2.572A6.43 6.43 0 0 1 2.456 11.2zM4.33 4.8H2.456A6.43 6.43 0 0 1 5.23 2.228c-.41.815-.712 1.68-.898 2.572zm5.07 8.142c-.502 1-1.04 1.458-1.4 1.458s-.896-.454-1.4-1.458a8.6 8.6 0 0 1-.624-1.742h4.048a8.6 8.6 0 0 1-.624 1.742m.91-3.342H5.69Q5.6 8.803 5.6 8t.09-1.6h4.62c.12 1.063.12 2.137 0 3.2m.46 4.172c.41-.815.712-1.68.898-2.572h1.876a6.43 6.43 0 0 1-2.774 2.572M14.4 8a6.4 6.4 0 0 1-.2 1.6h-2.28a16 16 0 0 0 0-3.2h2.28c.134.523.201 1.06.2 1.6"
    fill="currentColor"
  />,
  "World Globe",
  {
    viewBox: "0 0 16 16",
    titleAccess: "World Globe",
    fill: "none",
  }
);
